/// <reference path="../../../../tools/typings/angularjs/angular.d.ts"/>
/// <reference path="../../components.ts"/>


module DealerwareWebComponents {

    "use strict";

    import IAgreementPage = DealerwareWebContent.IAgreementPage;

    export class SettingsLoanerAgreementSetDirectiveController {

        public static $inject : string[ ] = [
            '$scope', '$state', '$mdDialog'
        ];

        private agreement: any;
        private unwatchAgreement: any;
        private unwatchAgreementPages: any;

        private selectedPage: IAgreementPage;

        private loanerAgreementService: any;


        constructor(
            private $scope       : ng.IScope,
            private $state       : any,
            private $mdDialog    : any
        ) {

            var that = this;

            this.unwatchAgreement = this.$scope.$watch( ( ) => {
                return that.loanerAgreementService && that.loanerAgreementService.agreement
            },
                (agreement: any ) => {
                    if (! agreement) {
                        return;
                    }

                    that.agreement = agreement;
                }
            );

            this.unwatchAgreementPages = this.$scope.$watch( ( ) => {
                    return that.loanerAgreementService && that.loanerAgreementService.agreement
                        && that.loanerAgreementService.agreement.pages;
                },
                (pages: any ) => {

                    if (pages === undefined || this.selectedPage) {
                        return;
                    }

                    that.selectedPage = pages.find( ( page: any ) => {
                        return page.selected;
                    });
                }, true
            );

            this.loanerAgreementService.setStepData(
                this.loanerAgreementService.getStepNameForRoute(this.$state)
            );
        }

        private selectPage ( newSelectedPageIndex: number ) : void {

            var that = this;

            // Page reselection means clearing out boxes and coordinates.  The coordinates are deleted here,
            // and the actual DOM element deletion &c happen when selectedPage is changed because of a watcher in
            // a descendent controller.
            //
            var doPageReselection = ( lastSelectedIndex?: number ) => {

                this.deleteSignatureDateCoordinates('set-signature');
                this.deleteSignatureDateCoordinates('set-date');

                this.agreement.pages.forEach( ( page: any, i: number ) => {

                    if (newSelectedPageIndex === i) {
                        page.selected = true;
                        that.selectedPage = page;
                        if (! isNaN(lastSelectedIndex)) {
                            that.selectedPage.lastSelectedIndex = lastSelectedIndex;
                        }
                    }
                    else {
                        page.selected = false;
                    }
                });

                // Then actually do the transition to selectPage.
                //
                that.goToPage('select-page');
            };

            // Clever people (and/or people with more time to spend on trivialities)
            // would probably find a way to do all of what these need to do with only
            // one time through the loop of pages.
            //
            // I'm not that guy, but it reminds of this interview question
            // I had once where I was supposed to do this bar graph analysis problem
            // going through the number of bars once rather than twice. I got neither
            // the problem nor the job; I didn't want to work for those tools anyway.
            //
            var currentSelectedPageIndex: number = -1;
            this.agreement.pages.some( ( page: any, i: number ) => {
                if (page.selected) {
                    currentSelectedPageIndex = i;
                    return true;
                }
            });

            // No page (ever) selected which is only possible on the first time
            // through the Select Page step.
            //
            if (currentSelectedPageIndex === -1) {
                this.agreement.pages[newSelectedPageIndex].selected = true;
                this.selectedPage = this.agreement.pages[newSelectedPageIndex];
            }

            // New page selected.
            //
            else if (currentSelectedPageIndex !== newSelectedPageIndex) {

                // Signature and maybe date have been already been set, so changing page will wipe
                // out these choices: confirm with user.
                //
                if (this.selectedPage.selected) {
                    var confirmationText = 'You are about to select a new page to place signatures and dates on. '
                        + 'Are you sure you want to do this?';

                    var confirm = this.$mdDialog.confirm()
                        .textContent(confirmationText)
                        .ariaLabel(confirmationText)
                        .ok('Yes, I want a new page')
                        .cancel('No, keep my current page');

                    this.$mdDialog.show(confirm)
                        .then(() => {
                            doPageReselection (currentSelectedPageIndex);
                        });
                }
                // No coordinate data set (first time select page), so allow.
                //
                else {
                    doPageReselection (currentSelectedPageIndex);
                }
            }
        }

        private setSignatureDateCoordinates ( stepName: string, coordinateData: any ) : void {

            var coordinateKeyPrefix = stepName === 'set-signature' ? 'signature' : 'date';

            this.agreement.pages.forEach( ( page: any ) => {

                if (page.selected) {
                    page[coordinateKeyPrefix + 'X']        = coordinateData.left;
                    page[coordinateKeyPrefix + 'Y']        = coordinateData.top;
                    page[coordinateKeyPrefix + 'Width']    = coordinateData.width;
                    page[coordinateKeyPrefix + 'Height']   = coordinateData.height;
                }
            });
        }

        private deleteSignatureDateCoordinates ( stepName: string ) : void {

            var coordinateKeyPrefix = stepName === 'set-signature' ? 'signature' : 'date';

            delete (<any>this.selectedPage)[coordinateKeyPrefix + 'X'];
            delete (<any>this.selectedPage)[coordinateKeyPrefix + 'Y'];
            delete (<any>this.selectedPage)[coordinateKeyPrefix + 'Width'];
            delete (<any>this.selectedPage)[coordinateKeyPrefix + 'Height'];
        }

        private isPageSelected ( ) : boolean {

            if (! this.agreement || ! this.agreement.pages) {
                return false;
            }

            // If pageIndex given, check to see if the page at that index is selected.
            // Otherwise, if not given, just check to see if *any* page is selected.
            //
            var selectedPageIndex = -1;
            return this.agreement.pages.some( ( page: any ) => {
                selectedPageIndex++;
                return page.selected;
            });
        }

        private isSignatureDefined() : boolean {

            return this.loanerAgreementService ?
                this.loanerAgreementService.isSignatureDefined.call (this.loanerAgreementService) :
                false;
        }

        private isDateDefined() : boolean {

            return this.loanerAgreementService ?
                this.loanerAgreementService.isDateDefined.call (this.loanerAgreementService) :
                false;
        }

        private goToPage ( stepName: string ) : void {

            var that = this;

            return this.loanerAgreementService.goToPage.call (
                this.loanerAgreementService, this.$state, stepName
            )
                .then( ( ) => {
                    // Keep stubbed as a reminder that we can do post-navigation actions.
                });
        }

        private checkThisStep ( stepName: string ) : boolean {

            return this.loanerAgreementService.checkThisStep.call (
                this.loanerAgreementService, this.$state, stepName
            );
        }

        private isCoordinateDataChanged ( ) : boolean {

            return Object.keys(this.loanerAgreementService.getChangedPageCoordinateData(
                this.selectedPage
            )).length > 0;
        }

        private saveLoanerAgreement ( nextStepName: string ) : void {

            var that = this;

            return this.loanerAgreementService.savePage.call (
                this.loanerAgreementService, this.selectedPage.id
            )
                .then( () => {
                    that.goToPage (nextStepName);
                    that.loanerAgreementService.resolveLoanerAgreementState (
                        that.$state, this.loanerAgreementService.isUploaded()
                    )
                });
        }

        private $destroy () : void {
            this.unwatchAgreement();
            this.unwatchAgreementPages();
        }
    }

    getDealerwareWebComponentsModule().controller(
        'SettingsLoanerAgreementSetDirectiveController',
        SettingsLoanerAgreementSetDirectiveController
    );


    export class SettingsLoanerAgreementSetDirective implements ng.IDirective {
        public restrict         : string    =   'E';
        public controller       : any       =   'SettingsLoanerAgreementSetDirectiveController';
        public controllerAs     : string    =   'LAS';
        public bindToController : boolean   =   true;
        public templateUrl      : string    =   '/components/settings/loaner-agreement/set-directive.html';
        public scope            : Object    =   {
            loanerAgreementService  : '=',
            agreement               : '='
        };
    }

    getDealerwareWebComponentsModule().directive(
        'dealerwareSettingsLoanerAgreementSet',
        ( ) => new SettingsLoanerAgreementSetDirective()
    );
}

